import {Typography, styled} from '@mui/material';

const StyledTypography = styled(Typography)`
	scroll-margin-top: 200px;
`;

export {StyledTypography};
